module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s((_vm.company && _vm.company._id ? (_vm.evaluate.alias ? _vm.evaluate.alias : _vm.evaluate.name) : _vm.evaluate.name) + (_vm.company && _vm.company._id ? ('-' + _vm.company.name) : '')))]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('span', {
    staticClass: "item"
  }, [_vm._v("本次测试共\n          "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.evaluate.questions_num))]), _vm._v("题")]), _vm._v(" "), _c('span', {
    staticClass: "item"
  }, [_vm._v(",剩余\n          "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.questions.length - _vm.index))]), _vm._v("题")]), _vm._v(" "), (_vm.evaluate.duration !== -1) ? _c('span', {
    staticClass: "item right"
  }, [_vm._v("\n          倒计时:\n          "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.duration_text))])]) : _vm._e()]), _vm._v(" "), (_vm.evaluate.show_type === 2) ? _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.evaluate.desc)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questions.length === 0 || _vm.loading === 1),
      expression: "questions.length === 0 || loading === 1"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center",
    staticStyle: {
      "height": "300px",
      "line-height": "300px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.load_msg) + "\n          ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questions.length > 0 && _vm.loading === 0),
      expression: "questions.length > 0 && loading === 0"
    }]
  }, _vm._l((_vm.questions), function(question, qindex) {
    return _c('div', {
      key: question._id,
      class: {
        'que-lock': question.locked, 'que-loading': question.loading, 'current': question._id === _vm.que._id
      },
      attrs: {
        "id": 'que-' + question._id
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.evaluate.show_type === 2) || (question._id === _vm.que._id)),
        expression: "(evaluate.show_type === 2) || (question._id === que._id)"
      }],
      staticClass: "question"
    }, [_c('div', {
      staticClass: "title clearfix"
    }, [_c('div', {
      staticClass: "index"
    }, [_vm._v("Q" + _vm._s((_vm.evaluate.questions_num - _vm.questions.length) + qindex + 1) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "body"
    }, [(question.title.length > 0) ? _c('div', [_vm._v(_vm._s(question.title))]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (question.title_duration != 0),
        expression: "question.title_duration != 0"
      }],
      domProps: {
        "innerHTML": _vm._s(question.title_rich)
      }
    })])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (question.title_duration <= 0),
        expression: "question.title_duration <= 0"
      }],
      staticClass: "options"
    }, [(question.category === 1 || question.category === 2 || question.category === 5) ? _c('div', [_c('ul', {
      class: {
        'list': question.option_layout_type === 1, 'grid': question.option_layout_type === 2, 'list-without-identifier': question.option_layout_type === 3, 'grid-without-identifier': question.option_layout_type === 4
      }
    }, _vm._l((question.options), function(option, oindex) {
      return _c('li', {
        key: option._id,
        staticClass: "option",
        class: {
          'selected': option.is_selected == 1
        },
        on: {
          "click": function($event) {
            _vm.optionSelected(option, question)
          }
        }
      }, [_c('span', {
        staticClass: "identifier"
      }, [_vm._v(_vm._s(_vm._f("upper")(_vm._f("toChar")((oindex + 97)))))]), _vm._v(" "), (option.category === 1) ? _c('span', [_vm._v(_vm._s(option.content))]) : _vm._e(), _vm._v(" "), (option.category === 2) ? _c('span', [_c('img', {
        attrs: {
          "src": option.image.url,
          "alt": option.image.name
        }
      })]) : _vm._e()])
    }))]) : _vm._e(), _vm._v(" "), (question.category === 3) ? _c('div', {
      staticClass: "duality"
    }, [_c('div', {
      staticClass: "option col-sm-5",
      class: {
        'selected': question.options[0].is_selected == 1
      },
      on: {
        "click": function($event) {
          _vm.optionSelected(question.options[0], question)
        }
      }
    }, [_c('div', {
      staticClass: "body red"
    }, [(question.options[0].category === 1) ? _c('span', [_vm._v(_vm._s(question.options[0].content))]) : _vm._e(), _vm._v(" "), (question.options[0].category === 2) ? _c('span', [_c('img', {
      attrs: {
        "src": question.options[0].image.url,
        "alt": question.options[0].image.name
      }
    })]) : _vm._e()])]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "option col-sm-5",
      class: {
        'selected': question.options[1].is_selected == 1
      },
      on: {
        "click": function($event) {
          _vm.optionSelected(question.options[1], question)
        }
      }
    }, [_c('div', {
      staticClass: "body blue"
    }, [(question.options[1].category === 1) ? _c('span', [_vm._v(_vm._s(question.options[1].content))]) : _vm._e(), _vm._v(" "), (question.options[1].category === 2) ? _c('span', [_c('img', {
      attrs: {
        "src": question.options[1].image.url,
        "alt": question.options[1].image.name
      }
    })]) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "b-b b-dashed m-t-b-sm"
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "actions m-t-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.resume_select_show === 1) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "user-resume-selects"
    }
  }, [_vm._v("选择简历(可选):")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.evaluate_result.resume_id),
      expression: "evaluate_result.resume_id"
    }],
    staticClass: "select input-sm",
    attrs: {
      "id": "user-resume-selects"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.evaluate_result.resume_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.resumeChange()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("选择已有简历")]), _vm._v(" "), _vm._l((_vm.resumes), function(resume) {
    return _c('option', {
      key: resume._id,
      domProps: {
        "value": resume._id
      }
    }, [_vm._v(_vm._s(resume.name) + "-" + _vm._s(resume.post_name))])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "type": "button",
      "disabled": !_vm.evaluate_result.resume_id
    },
    on: {
      "click": function($event) {
        _vm.previewResume()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search p-r-xs"
  }), _vm._v(" 预览")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.evaluate_result.resume_name),
      expression: "evaluate_result.resume_name"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 p-t-sm"
  }, [_vm._v("\n                上传简历：\n                "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.evaluate_result.resume_name))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-t-sm"
  }, [(_vm.evaluate.show_type === 1 && _vm.que.option_category !== 1 && (_vm.index < _vm.questions.length - 1)) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一题")]) : _vm._e(), _vm._v(" "), (_vm.evaluate.show_type === 2 || (_vm.evaluate.category === 2 && _vm.index === _vm.questions.length - 1)) ? _c('button', {
    staticClass: "btn btn-md btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.is_completed
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("完成测评")]) : _vm._e()])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hidden-click-actions"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option col-md-2"
  }, [_c('img', {
    staticClass: "vs",
    attrs: {
      "src": "/assets/images/vs.gif",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "id": "resume-upload-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload p-r-xs"
  }), _vm._v("上传")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticClass: "text-center m-t-b-sm"
  }, [_vm._v("本次测评由\n            "), _c('a', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "href": "http://www.psych.cas.cn",
      "title": "中国科学院心理研究所",
      "alt": "中国科学院心理研究所"
    }
  }, [_vm._v("中国科学院心理研究所")]), _vm._v(" 提供测评技术支持")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf7435e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluate/start.vue
// module id = 500
// module chunks = 1